var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24.5,
    width: 24,
    height: 36,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.75 23.25H24.625C22.5539 23.25 20.875 24.9289 20.875 27V57C20.875 59.0711 22.5539 60.75 24.625 60.75H43.375C45.4461 60.75 47.125 59.0711 47.125 57V42",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 55.5,
    r: 1.5,
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7473 23.4741C58.1408 22.8673 57.4206 22.3859 56.628 22.0575C55.8354 21.7291 54.9859 21.5601 54.1279 21.5601C53.2699 21.5601 52.4204 21.7291 51.6278 22.0575C50.8352 22.3859 50.115 22.8673 49.5085 23.4741L48.2498 24.7329L46.991 23.4741C45.7659 22.249 44.1043 21.5607 42.3716 21.5607C40.639 21.5607 38.9774 22.249 37.7523 23.4741C36.5271 24.6992 35.8389 26.3609 35.8389 28.0935C35.8389 29.8261 36.5271 31.4877 37.7523 32.7129L39.011 33.9716L48.2498 43.2103L57.4885 33.9716L58.7473 32.7129C59.3541 32.1063 59.8354 31.3862 60.1639 30.5936C60.4923 29.801 60.6613 28.9514 60.6613 28.0935C60.6613 27.2355 60.4923 26.386 60.1639 25.5934C59.8354 24.8008 59.3541 24.0806 58.7473 23.4741Z",
    fill: "#8E8CEE",
    stroke: "#8E8CEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.25 26.5V34.6429",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1787 30.5H52.3216",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(17.5 18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneHeart);
export default __webpack_public_path__ + "static/media/phone-heart.bfe30486a017ed4a478bd85b1e2dabf9.svg";
export { ForwardRef as ReactComponent };